import React from 'react'
import PropTypes from 'prop-types'
import { ConnectedRouter } from 'connected-react-router'
import routes from './routes'
import {connect} from 'react-redux'
import './scss/index.scss';

// import { Route, Switch, Router } from 'react-router'

const App = ({ history }) => {
  
  return (
    <ConnectedRouter history={history}>
      { routes }
    </ConnectedRouter>
  )
}

App.propTypes = {
  history: PropTypes.object,
}
export default connect( store => {
  
  return {
      login: store.loginInfo
  };
})(App);
